import React from 'react'
import { object } from 'prop-types'
import { AvgPrice, PriceBox, PriceLegendWrapper } from './FlexDatesRoundTrip.styles'

/**
 * Price Legend for the grid
 * @param {priceThresold} = object {low, middle, high}
 * @returns PriceLegend component
 */

export const PriceLegend = ({ priceThreshold }) => {
  const { low, middle, high } = priceThreshold
  return (
    <PriceLegendWrapper mt={2}>
      <AvgPrice mr={2}>avg. price</AvgPrice>
      <PriceBox p={1} m={1} bg={'pricePrimary.light'}>{`$${Math.min(middle, low) || ''}`}</PriceBox>
      <PriceBox p={1} m={1} bg={'caution.light'}>
        {`$${Math.max(middle, low) || ''}+`}
      </PriceBox>
      {high > middle && <PriceBox p={1} m={1} bg={'promoSecondary.light'}>{`$${high}`}</PriceBox>}
    </PriceLegendWrapper>
  )
}

// Proptypes
PriceLegend.propTypes = {
  priceThreshold: object,
}
